import React, { Component, useEffect, useState } from "react";
import { Tabs, Divider, Button } from "antd";
import {
  AudioOutlined,
  VideoCameraOutlined,
  FileImageOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import ImagesTab from "./Images";

import _ from "lodash";

import "./styles/main.scss";
import { useGlobalStore } from "../../../../stores/globalBackendStore";

const defaultGroup = "_default";

const TabsMenu = (props) => {
  const {
    onSelect,
    initialActiveGroup,
    item,
    slides,
    handleRemoveFromSlide,
    onOrderChange,
    openEditSlideItem,
    feedType,
    onSlideItemChange,
  } = props;

  const checkInitialValue = (value) => {};

  const [imagesGroup, setImagesGroup] = useState(
    initialActiveGroup || defaultGroup,
  );

  const apiSetup = useGlobalStore((state) => state.apiSetup);

  const [visibleEdit, setVisibleEdit] = useState(false);

  const [visibleSlideEdit, setVisibleSlideEdit] = useState(false);
  const [editData, setEditData] = useState({
    uuid: "0",
    group: imagesGroup,
    content_type: "image",
  });

  const [editSlideData, setEditSlideData] = useState({ uuid: "0" });

  const onSelectMedia = (e, val) => {
    onSelect(e, val);
  };

  const isGroupExist = (groups, checkValue) => {
    return _.has(groups, checkValue);
  };
  return (
    <React.Fragment>
      <ImagesTab
        group={
          isGroupExist(
            _.get(apiSetup, "mediaLibrary.groups.image"),
            imagesGroup,
          )
            ? imagesGroup
            : defaultGroup
        }
        onSelect={onSelectMedia}
        initialActiveGroup={initialActiveGroup}
        visibleEdit={visibleEdit}
        setVisibleEdit={setVisibleEdit}
        editData={editData}
        setEditData={setEditData}
        visibleSlideEdit={visibleSlideEdit}
        setVisibleSlideEdit={setVisibleSlideEdit}
        editSlideData={editSlideData}
        setEditSlideData={setEditSlideData}
        slides={slides}
        handleRemoveFromSlide={handleRemoveFromSlide}
        openEditSlideItem={openEditSlideItem}
        onOrderChange={onOrderChange}
        feedType={feedType}
        onSlideItemChange={onSlideItemChange}
      />
    </React.Fragment>
  );
};

const Index = (props) => {
  const {
    src,
    poster,
    className,
    onSelect,
    initialActiveGroup,
    item,
    handleRemoveFromSlide,
    slides,
    onOrderChange,
    openEditSlideItem,
    feedType,
    onSlideItemChange,
  } = props;

  useEffect(() => {});

  return (
    <>
      <TabsMenu
        initialActiveGroup={initialActiveGroup}
        onSelect={onSelect}
        item={item}
        slides={slides}
        handleRemoveFromSlide={handleRemoveFromSlide}
        onOrderChange={onOrderChange}
        openEditSlideItem={openEditSlideItem}
        feedType={feedType}
        onSlideItemChange={onSlideItemChange}
      />
    </>
  );
};

export default Index;
